import { useState } from 'react';
import classnames from 'classnames';
import { Select as AntdSelect, SelectProps } from 'antd';

import './style.scss';

const PREFIX = 'music';
const EXPAND_ICON = 'https://akoss.bangcdn.net/fe/Expand.svg';
const COLLAPSE_ICON = 'https://akoss.bangcdn.net/fe/Collapse.svg';

export interface MusicSelectProps extends Omit<SelectProps, 'popupClassName'> {
  unactive?: boolean;
}

export function Select(props: MusicSelectProps) {
  const { className, classNames: customClassNames, unactive, suffixIcon, onOpenChange, ...rstProps } = props;
  const [open, setOpen] = useState(false);

  const defaultSuffixIcon = (
    <img
      src={open ? COLLAPSE_ICON : EXPAND_ICON}
      alt=""
      className={`${PREFIX}-select-arrow`}
      width={24}
      height={24}
      style={{ display: 'block' }}
    />
  );

  const handleOpenChange = (visible: boolean) => {
    setOpen(visible);
    onOpenChange?.(visible);
  };

  return (
    <AntdSelect
      className={classnames(
        `${PREFIX}-select`,
        { unactive },
        className
      )}
      classNames={{
        ...customClassNames,
        popup: {
          ...customClassNames?.popup,
          root: classnames(`${PREFIX}-select-dropdown`, customClassNames?.popup?.root),
        },
      }}
      showArrow
      suffixIcon={suffixIcon !== undefined ? suffixIcon : defaultSuffixIcon}
      onOpenChange={handleOpenChange}
      {...rstProps}
    />
  );
}

Select.Option = AntdSelect.Option;
Select.OptGroup = AntdSelect.OptGroup;

export default Select;
